import { Instance, Props as TippyProps } from 'tippy.js';
import headerTooltip from './popovers/headerTooltip';
import { IHeaderParams } from 'ag-grid';
import { InputDataDefinitionsStore } from '@/apps/timeSeriesViewer/stores';
import { TooltipInfoDto } from '@/repositories';
import { IHeaderComp } from 'ag-grid/dist/lib/headerRendering/header/headerComp';

export class ColHeaderRenderer implements ITooltipHeaderRendererComp<TooltipInfoDto, IHeaderRendererParams> {
  private readonly _iconElement: HTMLElement;
  private _tooltip: Instance<TippyProps> | undefined;

  constructor() {
    this._iconElement = document.createElement('div');
  }

  init(params: ITooltipHeaderRendererParams<TooltipInfoDto> & IHeaderRendererParams): void {
    // This creates the same contents as created by ag-grids default renderer by then adds a tooltip.
    this._iconElement.innerHTML = `
    <div ref="eLabel" class="ag-header-cell-label" role="presentation">
      <span ref="eText" class="ag-header-cell-text" role="columnheader">${params.header}</span>
      <span ref="eFilter" class="ag-header-icon ag-filter-icon ag-hidden" aria-hidden="true"><span class="ag-icon ag-icon-filter"></span></span>
    </div>`;
    this._tooltip ??= headerTooltip(this._iconElement, params.tooltipInfo);
  }

  destroy(): void {
    this._tooltip?.destroy();
    this._tooltip = undefined;
  }

  getGui(): HTMLElement {
    return this._iconElement;
  }
}

export interface IHeaderRendererParams {
  rawDataDefinitionsStore: InputDataDefinitionsStore;
}

interface ITooltipHeaderRendererComp<TTooltipInfo, TParams> extends IHeaderComp {
  init(params: ITooltipHeaderRendererParams<TTooltipInfo> & TParams): void;
}

interface ITooltipHeaderRendererParams<T> extends IHeaderParams {
  header: string;
  tooltipInfo: T;
}
